/* Progressive enhancement; commerce remains owned by Dawn and Shopify. */
(() => {
  if (!customElements.get('fuji-product-tabs')) {
    customElements.define('fuji-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if(this.dataset.enhanced)return;
        this.tabs=[...this.querySelectorAll('[role="tab"]')];
        this.panels=[...this.querySelectorAll('[role="tabpanel"]')];
        this.select=tab=>{
          this.tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
          this.panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));
        };
        this.addEventListener('click',event=>{const t=event.target.closest('[role="tab"]');if(t&&this.contains(t))this.select(t);});
        this.addEventListener('keydown',event=>{
          const i=this.tabs.indexOf(event.target);
          if(i<0||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          const next=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:(i+(event.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;
          this.select(this.tabs[next]);this.tabs[next].focus();
        });
        if(this.tabs[0])this.select(this.tabs[0]);
        this.dataset.enhanced='true';
      }
    });
  }
  if(!customElements.get('fuji-card-swatches')) {
    customElements.define('fuji-card-swatches',class extends HTMLElement {
      connectedCallback(){
        if(this.dataset.enhanced)return;
        this.dataset.enhanced='true';
        this.querySelectorAll('[data-fuji-card-color]').forEach(a=>{
          if(a.dataset.image&&this.closest('.card')?.querySelector('.card__media img')){
            a.setAttribute('role','button');a.setAttribute('aria-pressed','false');
          }
        });
        this.addEventListener('click',event=>{
          const choice=event.target.closest('[data-fuji-card-color]');
          if(!choice||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0)return;
          const card=this.closest('.card');
          const image=card?.querySelector('.card__media img');
          if(!card||!image||!choice.dataset.image)return;
          event.preventDefault();event.stopPropagation();
          this.querySelectorAll('[data-fuji-card-color][role="button"]').forEach(a=>a.setAttribute('aria-pressed',String(a===choice)));
          if(image&&choice.dataset.image){
            image.src=choice.dataset.image;
            if(choice.dataset.imageSrcset)image.srcset=choice.dataset.imageSrcset;else image.removeAttribute('srcset');
            image.alt=`${card.querySelector('.card__heading')?.textContent.trim()||''} / ${choice.dataset.color}`;
          }
          card.classList.toggle('fuji-color-selected',Boolean(choice.dataset.image));
          card.querySelectorAll('.card__heading a, .fuji-card-media-link').forEach(a=>a.href=choice.href);
          const soldOut=choice.dataset.available==='false';
          const onSale=choice.dataset.onSale==='true';
          card.querySelectorAll('[data-fuji-card-badge]').forEach(badge=>{
            if(badge.dataset.releaseBlocked==='true')return;
            badge.textContent=soldOut?badge.dataset.soldOut:onSale?badge.dataset.sale:'';
            badge.hidden=!soldOut&&!onSale;
            card.querySelectorAll('.card__heading a[id]').forEach(link=>{
              const ownBadge=link.id.startsWith('StandardCardNoMediaLink-')
                ?link.id.replace('StandardCardNoMediaLink-','NoMediaStandardBadge-')
                :link.id.replace('CardLink-','Badge-');
              if(ownBadge===badge.id)link.setAttribute('aria-labelledby',`${link.id}${badge.hidden?'':` ${badge.id}`}`);
            });
          });
          const price=card.querySelector('.card-information .price');
          if(price&&choice.dataset.price){
            price.querySelectorAll('.price-item--regular').forEach(p=>p.textContent=choice.dataset.onSale==='true'?choice.dataset.comparePrice:choice.dataset.price);
            price.querySelectorAll('.price-item--sale').forEach(p=>p.textContent=choice.dataset.price);
            price.classList.remove('price--no-compare');
            price.querySelectorAll('[data-fuji-compare]').forEach(slot=>slot.hidden=!onSale);
            price.classList.toggle('price--on-sale',choice.dataset.onSale==='true');
            price.classList.toggle('price--sold-out',soldOut);
          }
        });
        this.addEventListener('keydown',event=>{
          if(event.key===' '&&event.target.matches('[data-fuji-card-color][role="button"]')){event.preventDefault();event.target.click();}
        });
      }
    });
  }
  let dialog,photos=[],position=0,photoTrigger;
  function show(index){
    position=(index+photos.length)%photos.length;
    const current=photos[position];
    dialog.querySelector('img').src=current.href;
    dialog.querySelector('img').alt=current.querySelector('img')?.alt||'FUJI';
    dialog.querySelector('[data-position]').textContent=`${position+1} / ${photos.length}`;
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[data-fuji-image]');
    if(!link||!window.HTMLDialogElement||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0)return;
    event.preventDefault();
    photos=[...link.closest('.fuji-look-grid').querySelectorAll('a[data-fuji-image]')];
    photoTrigger=link;
    if(!dialog){
      dialog=document.createElement('dialog');dialog.className='fuji-lightbox';dialog.setAttribute('aria-label','ルックを拡大');
      dialog.innerHTML='<button type="button" class="fuji-lightbox-close" data-close>CLOSE</button><img alt=""><div class="fuji-lightbox-controls"><button type="button" data-prev aria-label="前の写真">PREV</button><span data-position></span><button type="button" data-next aria-label="次の写真">NEXT</button></div>';
      document.body.append(dialog);
      dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
      dialog.querySelector('[data-prev]').addEventListener('click',()=>show(position-1));
      dialog.querySelector('[data-next]').addEventListener('click',()=>show(position+1));
      dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(position+(e.key==='ArrowRight'?1:-1));}});
      dialog.addEventListener('close',()=>photoTrigger?.focus());
    }
    dialog.querySelectorAll('[data-prev],[data-next]').forEach(button=>button.hidden=photos.length<2);
    show(photos.indexOf(link));dialog.showModal();
  });
})();
